import { render } from "./EChartsMixins.vue?vue&type=template&id=f5c12604"
import script from "./EChartsMixins.vue?vue&type=script&lang=js"
export * from "./EChartsMixins.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__